import { useEffect, useState } from 'react';
import '../../../src/styles/modalerror.scss';
import ScannedCardsCol from '../../components/Session/ScannedCardsCol';
import SessionUI from '../../components/Session/SessionUI';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RepositoryFactory } from '../../repository/RepositoryFactory';
import ModalInterface from '../../components/core/ModalInterface';
import { getcardOrders } from '../../store/actions/orderAction';
import CountCard from '../../components/Session/CountCard';
import { Button, Card, Container, Row } from 'react-bootstrap';
import { mergeSessionsThroughCards, updaterSessionPager } from '../../store/actions/tableActions';
import Form from 'react-bootstrap/Form';

const Payment = ({ setLocation }) => {
  const [pagerNumber, setPagerNumber] = useState(null);
  const [cardData, setCardData] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [alreadyExsistingCardsOfSession, setAlreadyExsistingCardsOfSession] = useState([]);
  const [isFirstScane, setIsFirstScane] = useState(true);
  const [firstScaneCard, setFirstScaneCard] = useState('');
  const [mergeCardId, setMergeCardId] = useState('');
  const [mergeSessionModal, setMergeSessionModal] = useState(false);
  const [refetchcardSession, setRefectchCardSession] = useState('');
  const [sessionId, setSessionId] = useState('');
  const loading = useSelector((state) => state.order.orderLoading);
  const sessionLoading = useSelector((state) => state.table.updateSessionLoader);
  const mergeSessionsLoader = useSelector((state) => state.table.mergeSessionsLoader);
  const [pagerModal, setPagerModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // setLocation(window.location.pathname)
  useEffect(() => {
    setLocation(window.location.pathname);
  }, []);
  const handleUpdate = () => {
    if (!pagerNumber) {
      setPagerModal(true);
      return;
    }
    handleSubmit();
  };
  const handleSubmit = () => {
    if (!alreadyExsistingCardsOfSession.length) {
      setShowModal(true);
      setErrorMsg('Please scane card first');
      return;
    }
    let obj = {
      cardId: alreadyExsistingCardsOfSession[0],
      businessLocationId: 771247277342722
    };
    dispatch(getcardOrders(obj)).then((resp) => {
      if (resp.success) {
        if (resp?.data[0]?.payment_status === 'paid') {
          setShowModal(true);
          setErrorMsg('All Items Of This Order Is Paid');
          return;
        }
        if (resp?.data[0]?.salesEntries?.length) {
          navigate('/new-session-orders');
          return;
        }
        setShowModal(true);
        setErrorMsg('There is No Order For This Card');
      } else {
        setShowModal(true);
        setErrorMsg('Error Occured' + resp?.data?.message);
      }
    });
  };

  const mergeSesionHandler = (id) => {
    let payload = {
      sourceSessionCard: mergeCardId,
      targetSessionCard: alreadyExsistingCardsOfSession[0]
    };
    dispatch(mergeSessionsThroughCards(payload)).then((res) => {
      if (res.success) {
        setRefectchCardSession(alreadyExsistingCardsOfSession[0]);
        setMergeSessionModal(false);
        setMergeCardId('');
      } else {
        setShowModal(true);
        setErrorMsg('Error Occured' + res?.data?.message);
        setMergeSessionModal(false);
        setMergeCardId('');
      }
    });
  };
  const updatePager = () => {
    if (!pagerNumber) {
      setShowModal(true);
      setErrorMsg('Please Add Pager Number');
      return;
    }
    dispatch(updaterSessionPager({sessionId,pagerNumber})).then((resp) => {
      setPagerModal(false);
      if (!resp.success) {
        setPagerNumber('')
        setPagerModal(false);
        setShowModal(true);
        setErrorMsg('Error Occured' + resp?.data?.message);
      } 
    });
  };

  useEffect(() => {
    if (mergeCardId) {
      setMergeSessionModal(true);
    }
  }, [mergeCardId]);
  return (
    <>
      <SessionUI
        pageTitle={'KASSIEREN'}
        imgCardColTitle={'KARTE SCANNEN'}
        firstScaneCard={firstScaneCard}
        setFirstScaneCard={setFirstScaneCard}
        isFirstScane={isFirstScane}
        setIsFirstScane={setIsFirstScane}
        cardData={cardData}
        setCardData={setCardData}
        setSessionId={setSessionId}
        isPayment={true}
        setAlreadyExsistingCardsOfSession={setAlreadyExsistingCardsOfSession}
        alreadyExsistingCardsOfSession={alreadyExsistingCardsOfSession}
        loading={loading}
        setMergeCardId={setMergeCardId}
        setPagerNumber={setPagerNumber}
        pagerNumber={pagerNumber}
        refetchcardSession={refetchcardSession}
        setRefectchCardSession={setRefectchCardSession}
        scannedCardCol={
          <ScannedCardsCol
            setCardData={setCardData}
            cardData={cardData}
            alreadyExsistingCardsOfSession={alreadyExsistingCardsOfSession}
            ScanCardsColTitle={'GESCANNTE KARTEN'}
            card_img_placeholder={'creditcard.png'}
            trashCan={false}
          />
        }
        thirdColCard={
          <CountCard
            ScanCardsColTitle={'  GESCANNTE PAGER'}
            countData={cardData.length + alreadyExsistingCardsOfSession?.length}
            card_img_placeholder={'creditcard.png'}
            pagerNumber={pagerNumber}
            isPager={true}
            trashCan={true}
            setpagerNumber={setPagerNumber}
          />
        }
        onClickFunc={handleUpdate}
        ABBRECHEN={() => navigate('/dashboard')}
        variant_ABBRECHEN={'vapiano-prim'}
        variant_BESTÄTIGEN={'vapiano-info'}
        cardImgSrc={'done-scan.png'}
      />
      <ModalInterface
        display={showModal}
        size="sm"
        footer={true}
        style={{ position: 'relative' }}
        handleClose={() => {
          setShowModal(false);
        }}
        bodyStyles={{ maxHeight: '100%', overflowY: 'scroll' }}
        content={<>{errorMsg}</>}
        cartFooter={<></>}
        className={'text-dark pt-2'}
        closeEvent={() => setShowModal(false)}
      />
      <ModalInterface
        display={mergeSessionModal}
        size="sm"
        style={{ position: 'relative', borderRadius: '12px' }}
        handleClose={() => {
          setMergeSessionModal(false);
          setMergeCardId('');
        }}
        bodyStyles={{ maxHeight: '100%', overflowY: 'scroll' }}
        content={
          <Container className="rounded-circle">
            <Row className="w-100 gx-0 gy-0 text-center">
              <div>
                <Card.Img
                  variant="top"
                  src={`img/deviceError.png`}
                  className="img-responsive img-card-title mt-2"
                  width={100}
                  height={80}
                />
              </div>
            </Row>

            <div className="errorModal-content my-4">
              <h5 className="text-center">ES SCHEINT, DASS DIESE KARTE</h5>
              <h5 className="text-center">NICHT ZU DIESER GRUPPE</h5>
              <h5 className="text-center">GEHÖRT</h5>
            </div>


            <div className="errorModal-content my-4">
              <h5 className="text-center">SOLL DIE KARTE</h5>
              <h5 className="text-center">HINZUGEFÜGT WERDEN?</h5>
            </div>

            <Row className="w-100 gx-0 gy-0 text-center my-4">
              <div className="errorModal-btn">
                <Button disabled={mergeSessionsLoader} onClick={mergeSesionHandler}>
                  {mergeSessionsLoader ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"></span>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center">
                      <span>
                        HINZUFÜGEN
                        <img src="/img/logout.png" className="mb-1 mx-1" />
                      </span>
                    </div>
                  )}
                </Button>
              </div>
            </Row>
            <Row className="w-100 gx-0 gy-0 text-center my-4">
              <div className="errorModal-btn">
                <button
                  onClick={() => {
                    setMergeSessionModal(false);
                    setMergeCardId('');
                  }}
                  style={{ backgroundColor: '#2f3e3f' }}
                  className=" border-0 ">
                  ABBRECHEN
                </button>
              </div>
            </Row>
          </Container>
        }
        className={'text-dark pt-2 wallet-modal'}
        closeEvent={() => {
          setMergeSessionModal(false);
          setMergeCardId('');
        }}
      />
      <ModalInterface
        display={pagerModal}
        size="lg"
        footer={true}
        style={{ position: 'relative' }}
        handleClose={() => {
          setPagerModal(false);
          setPagerNumber('');
        }}
        bodyStyles={{ maxHeight: '100%', overflowY: 'scroll' }}
        content={
          <>
            <Form.Control
              value={pagerNumber}
              onChange={(e) => {
                setPagerNumber(e.target.value);
              }}
              type="number"
              placeholder="Pager Number"
            />
          </>
        }
        footerContent={
          <>
            <Button
              onClick={() => {
                updatePager();
              }}
              style={{ backgroundColor: '#3498DB', border: 'none' }}
              type="submit">
              {sessionLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"></span>
              ) : (
                'Submit'
              )}
            </Button>
          </>
        }
        className={'text-dark pt-2'}
        closeEvent={() => setPagerModal(false)}
      />
    </>
  );
};

export default Payment;
